/*  THE KIT PAGE'S BUY BAR. Appears once the hero's buy button has gone, hides again as
    the closing one arrives, so two live buy buttons are never on screen at once.

    A PLAIN SCROLL LISTENER, NOT IntersectionObserver, and that is the same decision
    ev-sticky-bar.js made for Echo Valley. getBoundingClientRect is synchronous and always
    truthful. IntersectionObserver only delivers its callback on a rendering frame, so
    anywhere frames are throttled the bar silently never appears and nothing errors to
    say why. That failure mode is not hypothetical on this project: the screenshot overlay
    shipped with exactly it, opening invisible over a locked page because its reveal was
    waiting on a frame that never came. Here the equivalent is harmless, because a tab
    that is not being given frames is a tab nobody is scrolling, and measure() runs once
    inline at startup so a page restored mid scroll is already in the right state.

    IT MEASURES THE NAV RATHER THAN ASSUMING IT. The bar docks below .ev-topnav-bar, whose
    height differs between a phone and a desktop, so its bottom edge is read on every
    measure and written to --ev-ks-top. Hardcoding 45px would leave a gap on one breakpoint
    and an overlap on the other.

    THE BUTTON PRESSES THE HERO'S BUTTON. See the note in ev-kit-sticky.liquid: there is
    one buy path on the page and this is not a second one. It clicks rather than calling
    form.submit(), because submit() does not fire the submit event and would bypass
    ev-upsell.js, which is the whole thing that note is about.

    THE BAR SHIPS WITH THE hidden ATTRIBUTE and only ever loses it here, so if this file
    fails to load there is no half wired bar stuck across the page.  */
(function () {
  'use strict';

  var bar = document.getElementById('ev-kit-sticky');
  if (!bar) return;

  var heroForm = document.querySelector('.ev-kt-hero .ev-kt-buy');
  var heroBtn  = heroForm && heroForm.querySelector('button[type="submit"]');
  var closing  = document.querySelector('.ev-kt-close');
  var nav      = document.querySelector('.ev-topnav-bar');
  if (!heroForm || !heroBtn) return;

  bar.hidden = false;

  var ticking = false;

  function shouldShow () {
    var passedHero = heroForm.getBoundingClientRect().bottom < 0;
    /*  0.75 rather than 0: hand over to the closing button as it arrives, not once it is
        already centred, or both sit on screen together  */
    var closeNear = closing ? closing.getBoundingClientRect().top < innerHeight * 0.75 : false;
    return passedHero && !closeNear;
  }

  function measure () {
    ticking = false;
    if (nav) {
      var b = nav.getBoundingClientRect().bottom;
      bar.style.setProperty('--ev-ks-top', Math.max(0, Math.round(b)) + 'px');
    }
    bar.classList.toggle('is-up', shouldShow());
  }

  function onScroll () {
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) requestAnimationFrame(measure);
    else measure();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  measure();

  var btn = bar.querySelector('[data-ev-ks-buy]');
  if (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      heroBtn.click();
    });
  }

  /*  Exposed ONLY so the decision can be asserted from a console in environments where
      scroll events and frames are throttled and the class toggle cannot be observed.
      Reads state, changes nothing.  */
  bar.evShouldShow = shouldShow;
  bar.evMeasure = measure;
})();